// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ErrorProvider } from "./contexts/ErrorContext";

import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import EditingPage from "./components/EditingPage";
import ProtectedRoute from "./components/ProtectedRoute";
import UserProfilePage from "./components/UserProfilePage";
import LoginPage from "./components/LoginPage";
import RegisterPage from "./components/RegisterPage";
import ForgotPasswordPage from "./components/ForgotPasswordPage";
import TermsPage from "./components/TermsPage";
import PrivacyPage from "./components/PrivacyPage";

import SubscriptionPage from "./components/SubscriptionPage";
import ManageSubscriptionPage from "./components/ManageSubscriptionPage";
import ContributePage from "./components/ContributePage";
import CollaborationPage from "./components/CollaborationPage";
import ViewCardPage from "./components/GreetingCard/ViewCardPage";
import HelpPage from "./components/HelpPage";
import ArticlesPage from "./components/ArticlesPage";
import ArticlePage from "./components/ArticlePage";
import OccasionLandingPage from "./components/OccasionLandingPage";
import OccasionsHubPage from "./components/OccasionsHubPage";
import PhotoSwapPage from "./components/PhotoSwapPage";

// Conditional navbar that hides on certain routes
function ConditionalNavBar() {
  const location = useLocation();
  const hideNavRoutes = ['/card/', '/view/']; // Routes where nav should be hidden
  
  const shouldHideNav = hideNavRoutes.some(route => 
    location.pathname.startsWith(route)
  );
  
  return shouldHideNav ? null : <NavBar />;
}

// Conditional footer that hides on certain routes
function ConditionalFooter() {
  const location = useLocation();
  const hideFooterRoutes = ['/card/', '/view/']; // Routes where footer should be hidden
  
  const shouldHideFooter = hideFooterRoutes.some(route => 
    location.pathname.startsWith(route)
  );
  
  return shouldHideFooter ? null : <Footer />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ErrorProvider>
          <div className="flex flex-col min-h-screen">
            <ConditionalNavBar />
            <main className="flex-grow">
              <Routes>
                <Route path="/contribute/:id" element={<ContributePage />} />
                <Route path="/" element={<Hero />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route 
                  path="/edit/:category?/:id?" 
                  element={
                    <ProtectedRoute>
                      <EditingPage />
                    </ProtectedRoute>
                  } 
                />
                <Route path="/collaborate/:id" element={<CollaborationPage />} />
                <Route path="/view/:id" element={<ViewCardPage />} />
                <Route path="/card/:id" element={<ViewCardPage />} />
                <Route path="/help" element={<HelpPage />} />
                <Route path="/photo-swap" element={<PhotoSwapPage />} />
                <Route path="/articles" element={<ArticlesPage />} />
                <Route path="/articles/:articleId" element={<ArticlePage />} />
                <Route path="/subscribe" element={<SubscriptionPage />} />
                <Route path="/occasions" element={<OccasionsHubPage />} />
                <Route path="/occasions/:occasion" element={<OccasionLandingPage />} />
                <Route path="/manage" element={<ManageSubscriptionPage />} />
                <Route path="/contribute/:cardId" element={<ContributePage />} />
                <Route 
                  path="/profile" 
                  element={
                    <ProtectedRoute>
                      <UserProfilePage />
                    </ProtectedRoute>
                  } 
                />
                {/* Firebase Auth Handler for popups (Google sign-in, etc.) */}
                <Route 
                  path="/__/auth/handler" 
                  element={<div>Processing authentication...</div>}
                />
              </Routes>
            </main>
            <ConditionalFooter />
          </div>
        </ErrorProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}
